/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M9 4.5c0 2.2298-1.6217 4.0807-3.75 4.4378V16c0 1.7949 1.455 3.25 3.25 3.25h2.6893l-1.2196-1.2197a.75.75 0 1 1 1.0606-1.0606L14.0607 20l-3.0304 3.0303a.75.75 0 1 1-1.0606-1.0606l1.2196-1.2197H8.5c-2.6234 0-4.75-2.1266-4.75-4.75V8.9378C1.6217 8.5808 0 6.7298 0 4.5 0 2.0147 2.0147 0 4.5 0S9 2.0147 9 4.5Zm-1.5 0c0 1.6569-1.3431 3-3 3-1.6568 0-3-1.3431-3-3 0-1.6568 1.3432-3 3-3 1.6569 0 3 1.3432 3 3ZM24 19.5c0 2.4853-2.0147 4.5-4.5 4.5S15 21.9853 15 19.5c0-2.2306 1.623-4.0822 3.7525-4.4382A.79.79 0 0 1 18.75 15V7.5c0-1.795-1.4551-3.25-3.25-3.25h-2.6893l1.2196 1.2197a.75.75 0 0 1-1.0606 1.0606L9.9393 3.5 12.9697.4697a.75.75 0 0 1 1.0606 1.0607L12.8107 2.75H15.5c2.6234 0 4.75 2.1266 4.75 4.75V15a.79.79 0 0 1-.0025.0618C22.377 15.4178 24 17.2694 24 19.5Zm-1.5 0c0 1.6569-1.3431 3-3 3s-3-1.3431-3-3 1.3431-3 3-3 3 1.3431 3 3Z"
    clipRule="evenodd"
  />,
  'Commits'
);
